// extracted by mini-css-extract-plugin
export default {"container":"ContractAmount_container__q9z-1"};